@let fields = fieldsSg();

<div
  class="atn-mosaic-widget-fields__grid"
  [style.--max-columns]="columnCountSg()"
>
  @if (isOrderedSg()) {
    <ol
      [start]="startFromSg()"
      class="atn-mosaic-widget-fields__ordered-list"
    >
      @for (field of fields; track $index) {
        <li class="atn-mosaic-widget-fields__field">
          <atn-display-field
            [field]="field"
            (valueChange)="fieldValueChangeHandler($event, field.id)"
          />
        </li>
      }
    </ol>
  } @else {
    @for (field of fields; track $index) {
      <atn-display-field
        [field]="field"
        (valueChange)="fieldValueChangeHandler($event, field.id)"
      />
    }
  }
</div>
